import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[RM Document Types] Load';
export const LOAD_SUCCESS = '[RM Document Types] Load Success';
export const LOAD_FAIL = '[RM Document Types] Load Fail';

export class LoadAction implements Action {
  readonly type = LOAD;
}

export class LoadSuccessPayload {
  entities: Array<models.DocumentType>;
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;
  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;
